export default {
  loadingProfile: "Loading profile...",
  errorLoadingProfile: "Error loading profile",
  profileChangedTo: "Profile changed to {{type}}",
  sectionSaved: "Section saved successfully",
  saveSection: "Save section",
  revertSection: "Revert",
  checkHighlighted: "Please check the highlighted fields",
  pageTitle: "Settings",
  sectionsNav: "Sections",
  profileDescription: "Manage your profile, contact and payment details",
  confirmChangeTitle: "Change Profile Type?",
  confirmChangeMessage:
    'Switching from "{{from}}" to "{{to}}" will clear the {{dataType}}-specific fields (name, birth details, or company details). Address, contact, identity document, and payment details are kept.',
  individual: "Individual",
  company: "Company",
  confirmChange: "Yes, Change Type",
  adminPageTitle: "Settings",
  adminPageDescription: "Manage your account",
  adminCardTitle: "Staff Profile",
  adminBadge: "Staff",
  taxValidation: {
    vatNotFound: "VAT number not found in the registry.",
    vatMatched: "{{name}} · {{address}}",
    fiscalCodeInvalid: "Invalid tax ID.",
  },
  forms: {
    region: {
      cardTitle: "Payment region",
      hint: "Assigned when your account was created and cannot be changed.",
    },
    profileType: {
      cardTitle: "Profile Type",
      individualTitle: "Individual",
      individualDesc: "Private citizen",
      businessTitle: "Business",
      businessDesc: "Company or firm",
    },
    profileStatus: {
      completeTitle: "Profile Complete",
      incompleteTitle: "Profile Incomplete",
      incompleteDesc:
        "Please complete all required fields to activate your account",
    },
    person: {
      cardPersonal: "Personal Information",
      firstName: "First Name",
      lastName: "Last Name",
      birthDate: "Date of Birth",
      birthPlace: "Place of Birth",
      birthPlacePh: "City, Country",
      idAsShown: "As shown on ID",
      fiscalCode: "Tax ID / SSN",
      fiscalCodePh: "Your tax identification number",
      cardResidence: "Residence Address",
      cardIdentity: "Identity Document",
    },
    company: {
      cardBusiness: "Business Information",
      companyName: "Company Name",
      companyNamePh: "Acme Corporation Inc.",
      vatNumber: "VAT Number",
      vatNumberPh: "XX123456789",
      taxId: "Company Tax ID",
      taxIdPh: "Business tax identification number",
      cardRegistered: "Registered Address",
      cardLegalRep: "Legal Representative",
      fullName: "Full Name",
      fullNamePh: "John Smith",
    },
    address: {
      street: "Street Address",
      streetPh: "123 Main Street",
      postalCode: "Postal Code",
      postalPh: "12345",
      city: "City",
      cityPh: "New York",
      state: "State/Province",
      statePh: "NY",
      country: "Country",
      countryPh: "United States",
    },
    document: {
      type: "Document Type",
      typePh: "ID Card, Passport...",
      number: "Number",
      numberPh: "AB1234567",
      issuer: "Issuing Authority",
      issuerPh: "Government Office",
      issueDate: "Issue Date",
      expiryDate: "Expiry Date",
    },
    contact: {
      cardTitle: "Contact Information",
      phone: "Phone Number",
      phonePlaceholder: "+34 612 345 678",
      phoneHint:
        "Type the international prefix (e.g. +34) or pick a country; the flag updates automatically.",
      email: "Email",
      emailPh: "email@example.com",
      emailHint:
        "After saving, verify with the link we email you — no code needed.",
      pec: "Certified Email (PEC)",
      pecPh: "name@pec.com",
      pecHint: "For electronic invoicing",
      verified: "Verified",
      resendCode: "Resend code",
      resendLink: "Resend link",
      verifySaveFirst: "Save your changes first, then verify.",
      confirmCode: "Confirm",
      sendSmsCode: "Send SMS code",
      sendEmailLink: "Send verification email",
      enterSmsCode: "Enter the 6-digit code we just texted you.",
      otpAriaLabel: "SMS verification code",
      verifyPhoneSent: "SMS sent — enter the code below.",
      verifyEmailSent:
        "We sent a verification link. Open the email and click it (phone is fine) — no code needed. This page updates automatically.",
      verifyEmailWaiting:
        "Waiting for you to click the link in your email…",
      verifyPhoneSuccess: "Phone verified.",
      verifyEmailSuccess: "Email verified.",
      verifyPhoneLimit: "SMS limit reached. Try again later.",
      verifyEmailLimit: "Email limit reached. Try again later.",
      verifyConfirmLimit: "Too many attempts. Try again later.",
      verifyPhoneNotSmsCapable: "This number cannot receive SMS codes.",
      verifyCodeInvalid: "That code is invalid or expired.",
      notificationChannel: "Booking notifications",
      notificationChannelHint:
        "Choose where to receive alerts about new bookings, messages, and cancellations.",
      notificationChannelWhatsApp: "WhatsApp",
      notificationChannelEmail: "Email",
      notificationLanguage: "Notification language",
    },
    payment: {
      cardTitle: "Payment Information",
      iban: "IBAN",
      ibanOptional: "IBAN",
      ibanPh: "XX00 0000 0000 0000 0000 00",
      ibanHint: "15-34 characters",
      accountHolder: "Account Holder Name",
      accountHolderOptional: "Account Holder Name",
      accountHolderPh: "John Smith or Acme Inc.",
      accountHolderHint: "At least 3 characters",
    },
  },
} as const;
